import { useContext, useEffect, useRef, useState } from 'react';
import './PasteVideoUrl.less';
import { UploadContext } from '@/context/vidtranslate/UploadContext';
// import downImg from '@/assets/vidtranslate/down.svg';
import YoutoImg from '@/assets/vidtranslate/youto.png';
import { vidTranslation } from '@/api';
import { useDashboardData } from '@/hooks/DashboardHooks';
import { useDrawer } from '@/hooks/DrawerHooks.js';
import { useTranslation } from 'react-i18next';
import message from '@/utils/message';
// import { CheckEquity } from '@/utils/CheckEquity';
import { createYoutube } from '@/api/upload.js';
import ChooseLanguage from '@/components/chooseLanguage/ChooseLanguage.jsx';
import Icon from '@/components/iconfont/Icon.jsx';
import { Switch } from '@radix-ui/themes';
export default function PasteVideoUrl({ onUpload, onCreateSuccess }) {
  const { setIsOpen } = useDrawer();
  const {
    userData,
    pointConsume,
    youtobeCreateProject,
    languageList: defaultLanguage,
  } = useDashboardData();
  const [showSourceLanguage, setShowSourceLanguage] = useState(false);
  const [showTargetLanguage, setShowTargetLanguage] = useState(false);
  const [showPeopleCount, setShowPeopleCount] = useState(false);
  const isFirstRender = useRef(true);
  const {
    // pasteSubmitLoading,
    // setPasteSubmitLoading,
    pasteVideoUrl,
    setPasteVideoUrl,
    isValidVideoUrl,
    setIsValidVideoUrl,
    pastesourceLanguage,
    setPasteSourceLanguage,
    pastetargetLanguage,
    setPasteTargetLanguage,
    pastePeopleCount,
    setPastePeopleCount,
    languageList,
    targetLanguageList,
    propleList,
    pastesyncFlag,
    // sePastetSyncFlag,
    // pasteGenerateSpeech,
    // setPasteGenerateSpeech,
    pasteVideoDuration,
    setNotYoutoUrlShow,
    notYoutoUrlShow,
    setPasteVideoDuration,
    pasteVideoMinutes,
    setPasteVideoMinutes,
    youtoMessage,
    setYoutoMessage,
    setVidtranslateModalShow,
    // setSyncModalShow,
    showAddSubtitles,
    ttsState,
    setTtsState,
    translateState,
    setTranslateState,
    urlVideoTime,
    targetLanguageList_subtitle,
    languageList_subtitle,
    setDefaultLanguage,
  } = useContext(UploadContext);
  const [chooselanguageList, setChooselanguageList] = useState(languageList_subtitle);
  const [youtoLoading, setYoutoLoading] = useState(false);
  const youtubeImg = useRef('');
  const youtubeTempId = useRef('');
  const { t } = useTranslation();
  useEffect(() => {
    const handleClickOutside = (event) => {
      // 点击字体选择框以外的区域时关闭下拉列表
      const selectSourct = document.querySelector('.select_sourct');
      if (selectSourct && !selectSourct.contains(event.target)) {
        setShowSourceLanguage(false);
      }
      const selectTarget = document.querySelector('.select_target');
      if (selectTarget && !selectTarget.contains(event.target)) {
        setShowTargetLanguage(false);
      }
      const selectPeople = document.querySelector('.select_people');
      if (selectPeople && !selectPeople.contains(event.target)) {
        setShowPeopleCount(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    setNotYoutoUrlShow(false);
    setPasteVideoMinutes(0);
    pasteVideoUrl && validateUrl();
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  const handleSourceLanguage = (val) => {
    setPasteSourceLanguage(val);
  };
  const handleTargetLanguage = (val) => {
    setPasteTargetLanguage(val);
  };
  const handleChangePeople = (val) => {
    setPastePeopleCount(val);
  };
  // const handleCheckboxChangeSync = (e) => {
  //   window.onClickGATrackEvent('translate-click-lipsync');
  //   if (e.target.checked) {
  //     setSyncModalShow(true);
  //   }
  //   sePastetSyncFlag(e.target.checked);
  // };
  // const handleCheckboxChangeGenerate = (e) => {
  //   setPasteGenerateSpeech(e.target.checked);
  // };
  const handleCheckboxChangeTTS = (e) => {
    if (!showAddSubtitles && e) {
      window.onClickGATrackEvent('translate-toggle-tts');
    }
    setTtsState(e);
    // sendBuryPoint();
  };
  const handleCheckboxChangeTranslate = (e) => {
    if (showAddSubtitles && e) {
      window.onClickGATrackEvent('addsub-toggle-double');
    }
    setTranslateState(e);
    // sendBuryPoint();
  };
  useEffect(() => {
    if (showAddSubtitles) {
      const data = translateState ? targetLanguageList_subtitle : languageList_subtitle;
      setChooselanguageList(data);
      const isHave = data.find((res) => res.name === pastesourceLanguage.name);
      if (!isHave) {
        setDefaultLanguage(defaultLanguage);
      }
    }
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (pasteVideoMinutes <= 0) return;
    sendBuryPoint();
  }, [ttsState, translateState]);
  const handleChangeUrl = (e) => {
    setPasteVideoUrl(e.target.value);
    setIsValidVideoUrl(true);
    setYoutoMessage('');
    if (!e.target.value) {
      setNotYoutoUrlShow(false);
    }
  };
  const sendBuryPoint = (time) => {
    const stats = canTranslate(time || 0);
    if (!stats) {
      window.onClickGATrackEvent(
        showAddSubtitles ? 'addsub-need-upgrade' : 'translate-need-upgrade',
        { video_duration: time || pasteVideoMinutes, video_type: 'url' },
      );
    }
  };
  const canTranslate = (val) => {
    let type = '';
    if (!showAddSubtitles) {
      type = ttsState ? 'translation_and_tts' : 'translation';
    } else {
      type = translateState ? 'add_subtitle_and_translation' : 'add_subtitle';
    }
    const consume = pointConsume?.filter((res) => res.mode === type);
    const needCredits = (val || pasteVideoMinutes) * consume[0]?.number;
    const user_credits = userData?.actualTotalPoints || 0;
    return user_credits >= needCredits;
  };
  const formatDuration = (duration) => {
    if (!duration) return '00:00';
    const minutes = Math.floor(duration / 60000);
    const seconds = Math.floor((duration % 60000) / 1000);
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };
  const formatMinutes = (milliseconds) => {
    if (!milliseconds) return 0;
    const minutes = milliseconds / 60000;
    return minutes % 1 === 0 ? minutes : Math.ceil(minutes);
  };
  const validateUrl = async () => {
    // 判断是否使用youtobe创建项目
    if (!youtobeCreateProject) {
      const state = pasteVideoUrl.includes('youtube.com');
      !state && setYoutoMessage(t('As_CreateProjectRewrite_ErrorYoutubeLink'));
      setNotYoutoUrlShow(state);
      return state;
    }
    if (!pasteVideoUrl) {
      setPasteVideoMinutes(0);
      return false;
    }
    const urlRegex = /^https?:\/\/.+/;
    setIsValidVideoUrl(urlRegex.test(pasteVideoUrl));
    if (!pasteVideoUrl) {
      setPasteVideoMinutes(0);
      setNotYoutoUrlShow(false);
      setYoutoMessage('');
      return false;
    }
    if (urlRegex.test(pasteVideoUrl)) {
      setYoutoLoading(true);
      let url_valid = false;
      try {
        const res = await vidTranslation.youtubeVideo({
          url: pasteVideoUrl,
        });
        console.log(res);
        if (res && res.code === 0) {
          // if (res.data.duration > 10 * 60 * 1000 && !CheckEquity({ userData, type: 'freeCount' })) {
          //   setNotYoutoUrlShow(false);
          //   setYoutoMessage('Please use the Youtube video less than 10 min');
          //   setYoutoLoading(false);
          //   return;
          // }
          // if (res.data.duration > 30 * 60 * 1000 && CheckEquity({ userData, type: 'freeCount' })) {
          //   setNotYoutoUrlShow(false);
          //   setYoutoMessage('Please use the Youtube video less than 30 min');
          //   setYoutoLoading(false);
          //   return;
          // }
          setPasteVideoDuration(formatDuration(res.data.duration));
          setPasteVideoMinutes(formatMinutes(res.data.duration));
          urlVideoTime.current = Math.round(res.data.duration / 1000);
          setYoutoMessage('');
          setNotYoutoUrlShow(true);
          sendBuryPoint(formatMinutes(res.data.duration));
          url_valid = true;
          youtubeImg.current = res.data?.image?.medium?.url;
          youtubeTempId.current = res.timestamp + Date.now();
        } else {
          throw new Error(t('As_CreateProjectRewrite_ErrorYoutubeLink'));
        }
      } catch (error) {
        setNotYoutoUrlShow(false);
        const err = JSON.parse(error);
        if (err.code === -1001) {
          setNotYoutoUrlShow(false);
          setYoutoMessage(t('As_CreateProjectRewrite_ErrorYoutubeLink'));
        } else {
          setYoutoMessage(error.msg);
        }
      }
      window.onClickGATrackEvent(
        showAddSubtitles ? 'addsub-url-processed' : 'translate-url-processed',
        { url_valid },
      );
      setYoutoLoading(false);
    } else {
      setPasteVideoMinutes(0);
    }
    return urlRegex.test(pasteVideoUrl);
  };
  // 无法使用youtobe创建项目的submit
  const invalidYouTubeProjectSubmit = async () => {
    message.info(`${t('As_Home_Soon')}\n${t('As_Home_Soon2')}`, {
      position: 'center',
    });
  };
  // 可以使用youtobe创建项目的submit
  const validYouTubeProjectSubmit = async () => {
    // if (pasteSubmitLoading) {
    //   return;
    // }
    const obj = {
      type: 3, // 增加type =3  上传youtube链接
      name: 'YouTube Project',
      usage: showAddSubtitles ? 2 : 1, // 0 重写  1 翻译
      youtubeUrl: pasteVideoUrl, // youtube链接
      language: pastesourceLanguage.name, // 原始语言（翻译项目需要传入）
      translationLanguage: pastetargetLanguage.name, // 目标语言（翻译项目需要传入）
      peopleNumber: pastePeopleCount.id,
      lipSync: pastesyncFlag, // 嘴型同步开关
      generateSpeech: showAddSubtitles ? false : ttsState, // 是否TTS
      useTranslate: showAddSubtitles ? translateState : true, // 是否翻译
      mode: showAddSubtitles ? 'add_subtitle' : 'translation',
      imgUrl: youtubeImg.current, //临时数据，用来在项目列表展示封面图
      tempId: youtubeTempId.current, // 临时id 用来替换真实id
    };
    if (!obj.useTranslate) {
      delete obj.translationLanguage;
    }
    // setPasteSubmitLoading(true);
    const obj1 = {
      uploadType: 1,
      usage: showAddSubtitles ? 2 : 1, // 0 重写  1 翻译
      url: pasteVideoUrl,
      sourceLanguage: pastesourceLanguage.name,
      targetLanguage: pastetargetLanguage.name,
      peopleNumber: pastePeopleCount.id,
      openLibSync: pastesyncFlag,
    };
    try {
      let res;
      setVidtranslateModalShow(false);
      onUpload(obj);
      if (!pastesyncFlag) {
        res = await createYoutube(obj);
      } else {
        res = await createYoutube(obj1);
      }
      console.log(res);
      if (res.code === 0) {
        onCreateSuccess(res.data);
        // setNeedRefreshProjects(Date.now());
      } else {
        message.error('Network error', {
          id: 'only',
        });
      }
    } catch (error) {
      console.log(error);
    }
    // setPasteSubmitLoading(false);
  };
  return (
    <div className="paste_box">
      <div className={`youto_box ${!isValidVideoUrl && 'error_video_url'}`}>
        <div className="video_url_title">
          <img src={YoutoImg} alt="" />
          <div className="line"></div>
        </div>
        <input
          type="text"
          value={pasteVideoUrl}
          className="video_url_input grow"
          onChange={handleChangeUrl}
          onBlur={validateUrl}
          placeholder="https://www.youtube.com/watch?v=xxxxxx"
          autoFocus
        />
        <div className="loading_box1">
          {youtoLoading && <span className="loading loading-spinner loading-sm"></span>}
        </div>
      </div>
      <div className="form_info">
        <div className="info_box video_language">
          <div className="text">
            {/* Video Language */}
            {t('As_CreateProjectTrans_VideoLang')}
          </div>
          <div className={`select_box select_sourct ${showSourceLanguage && 'select_action'}`}>
            <div
              className={`select_click_mask ${showSourceLanguage && 'select_click_mask_active'}`}
              onClick={() => {
                setShowSourceLanguage(!showSourceLanguage);
              }}></div>
            <div className="select_value">
              <div className="text">{pastesourceLanguage?.language || t('As_Home_SelectLang')}</div>
              <Icon name={showSourceLanguage ? 'icon-arrow-left' : 'icon-arrow-down'} />
            </div>
            {showSourceLanguage && (
              <div className="select_list choose_language">
                <ChooseLanguage
                  languageList={showAddSubtitles ? chooselanguageList : languageList}
                  language_action={pastesourceLanguage}
                  onChang={(item) => {
                    handleSourceLanguage(item);
                    setShowSourceLanguage(!showSourceLanguage);
                  }}
                />
              </div>
            )}
          </div>
        </div>
        {!showAddSubtitles && (
          <div className={`info_box target_language`}>
            {/* <div className="text">{showAddSubtitles ? 'Subtitle language' : 'Target Language'}</div> */}
            <div className="text">
              {showAddSubtitles
                ? t('As_CreateProjectSub_SubLang')
                : t('As_CreateProjectTrans_TargetLang')}
            </div>
            <div className={`select_box select_target  ${showTargetLanguage && 'select_action'}`}>
              <div
                className={`select_click_mask ${showTargetLanguage && 'select_click_mask_active'}`}
                onClick={() => {
                  setShowTargetLanguage(!showTargetLanguage);
                }}></div>
              <div className="select_value">
                <div className="text">{pastetargetLanguage?.language}</div>
                <Icon name={showTargetLanguage ? 'icon-arrow-left' : 'icon-arrow-down'} />
              </div>
              {showTargetLanguage && (
                <div className="select_list choose_language">
                  <ChooseLanguage
                    languageList={targetLanguageList}
                    language_action={pastetargetLanguage}
                    language_disabled={pastesourceLanguage}
                    onChang={(item) => {
                      handleTargetLanguage(item);
                      setShowTargetLanguage(!showTargetLanguage);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        )}

        <div className={`info_box speaker_num ${showAddSubtitles && 'hidden'}`}>
          <div className="text">
            {/* Speaker num */}
            {t('As_CreateProjectTrans_SpeakerNum')}
          </div>
          <div
            className={`select_box select_people ${showPeopleCount && 'select_click_mask_active'} ${showPeopleCount && 'select_action'}`}
            onClick={() => {
              setShowPeopleCount(!showPeopleCount);
            }}>
            <div className="select_value">
              <div className="text">{t(pastePeopleCount?.name)}</div>
              <Icon name={showPeopleCount ? 'icon-arrow-left' : 'icon-arrow-down'} />
            </div>
            <div
              className="select_list speaker_num_list"
              style={{ display: showPeopleCount ? 'block' : 'none' }}>
              {propleList.map((item, index) => (
                <div
                  key={index}
                  className={`select_item ${item.id === pastePeopleCount?.id && 'active_people_item'}`}
                  onClick={() => {
                    handleChangePeople(item);
                  }}>
                  {t(item.name)}
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* <div className={`info_box lips_sync ${showAddSubtitles && 'hidden'}`}>
          <div className="text">Generate speech</div>
          <input
            type="checkbox"
            className="toggle"
            checked={pasteGenerateSpeech}
            onChange={handleCheckboxChangeGenerate}
          />
        </div> */}
        {/* {pasteGenerateSpeech && ( */}
        {/* <div className={`info_box lips_sync ${showAddSubtitles && 'hidden'}`}>
          <div className="text">
            {t('As_CreateProjectTrans_Lip')}
          </div>
          <input
            type="checkbox"
            className="toggle"
            checked={pastesyncFlag}
            onChange={handleCheckboxChangeSync}
          />
        </div> */}
        {/* )} */}
        {showAddSubtitles ? (
          <div className={`info_box`}>
            <div className="text">{t('As_Edit_Subtitlechoice')}</div>
            <Switch
              className="toggle toggle_checkbox"
              checked={translateState}
              onCheckedChange={handleCheckboxChangeTranslate}
            />
          </div>
        ) : (
          <div className={`info_box`}>
            <div className="text">{t('As_Edit_TTS')}</div>
            <Switch
              className="toggle toggle_checkbox"
              checked={ttsState}
              onCheckedChange={handleCheckboxChangeTTS}
            />
          </div>
        )}
        <div
          className={`info_box target_language ${!(showAddSubtitles && translateState) && 'hidden'}`}>
          {/* <div className="text">{showAddSubtitles ? 'Subtitle language' : 'Target Language'}</div> */}
          <div className="text">{t('As_CreateProjectSub_SubLang')}</div>
          <div className={`select_box select_target ${showTargetLanguage && 'select_action'}`}>
            <div
              className={`select_click_mask ${showTargetLanguage && 'select_click_mask_active'}`}
              onClick={() => {
                setShowTargetLanguage(!showTargetLanguage);
              }}></div>
            <div className="select_value">
              <div className="text">{pastetargetLanguage?.language || t('As_Home_SelectLang')}</div>
              <Icon name={showTargetLanguage ? 'icon-arrow-left' : 'icon-arrow-down'} />
            </div>
            {showTargetLanguage && (
              <div className="select_list choose_language">
                <ChooseLanguage
                  languageList={chooselanguageList}
                  language_action={pastetargetLanguage}
                  language_disabled={pastesourceLanguage}
                  onChang={(item) => {
                    handleTargetLanguage(item);
                    setShowTargetLanguage(!showTargetLanguage);
                  }}
                />
              </div>
            )}
          </div>
        </div>

        <div className="btnbox">
          <div className="duration_info">
            {pasteVideoUrl && notYoutoUrlShow && userData?.userSubscription?.level > 1 && (
              <>
                <div className="duration">
                  <div className="text">
                    {/* Video duration */}
                    {t('As_CreateProjectTrans_VideoDuration')}
                  </div>
                  <div className="num">{pasteVideoDuration}</div>
                </div>
                <div className="duration">
                  <div className="text">
                    {/* Translation will consume */}
                    {t('As_CreateProjectTrans_CreditsCost')}
                  </div>
                  <div className="num">{pasteVideoMinutes} min</div>
                </div>
                <div className={`duration ${!canTranslate() && 'num_error'}`}>
                  <div className="text">
                    {/* My quota left */}
                    {t('As_CreateProjectTrans_CreditsLeft')}
                  </div>
                  <div className="num">
                    {userData?.userSubscription?.translationQuotaRemaining} min
                  </div>
                </div>
              </>
            )}
          </div>
          {canTranslate() && (
            <button
              className="btn btn-primary btn_submit"
              disabled={!notYoutoUrlShow || !pastesourceLanguage.name}
              onClick={() => {
                if (showAddSubtitles) {
                  window.onClickGATrackEvent('addsub-submit', {
                    source_lan: pastesourceLanguage.name,
                    dual_sub: translateState,
                    sub_lan: pastetargetLanguage.name,
                    video_type: 'url',
                  });
                } else {
                  window.onClickGATrackEvent('translate-submit', {
                    source_lan: pastesourceLanguage.name,
                    target_lan: pastetargetLanguage.name,
                    speaker_num: pastePeopleCount.id,
                    voice_translation: pastesyncFlag,
                    video_type: 'url',
                  });
                }
                youtobeCreateProject ? validYouTubeProjectSubmit() : invalidYouTubeProjectSubmit();
              }}>
              {/*{pasteSubmitLoading && <span className="loading loading-spinner loading-sm"></span>}*/}
              {t('As_CreateProjectTrans_Button')}
            </button>
          )}
          {!canTranslate() && (
            <>
              <button
                className="btn btn-warning btn_upgrade"
                onClick={() => {
                  window.onClickGATrackEvent(
                    showAddSubtitles ? 'addsub-click-upgrade' : 'translate-click-upgrade',
                  );
                  setIsOpen(true);
                }}>
                {/* Upgrade */}
                {t('As_Recording_Upgrade')}
              </button>
            </>
          )}
        </div>
        {youtoMessage && <div className="error_message">{youtoMessage}</div>}
      </div>
    </div>
  );
}
